import { NgModule } from '@angular/core';
//
import 
{ 
    MatButtonModule,
    MatCheckboxModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatRippleModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatDividerModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatChipsModule,
    MatListModule,
    MatProgressBarModule,
    MatBottomSheetModule
    
 } from '@angular/material';
 import { MatSliderModule } from '@angular/material/slider'

@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatGridListModule, 
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatTableModule,
        MatPaginatorModule,
        MatDialogModule,
        MatDividerModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatChipsModule,
        MatSliderModule,
        MatListModule,
        MatProgressBarModule,
        MatBottomSheetModule
    ],
    
    exports: [
        MatButtonModule, 
        MatCheckboxModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatTableModule,
        MatPaginatorModule,
        MatDialogModule,
        MatDividerModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatChipsModule,
        MatSliderModule,
        MatListModule,
        MatProgressBarModule,
        MatBottomSheetModule
    ],
})
export class MaterialModule { }